import { DutchAuctionOrder } from "@/api/orders/types";
import { getEIP712SignatureParams } from "@/eip712";
import { DUTCH_AUCTION_PARAMS } from "@/eip712/constants";
import { buildObject } from "@/shared/helpers";
import { useCallback } from "react";
import { useExchangeContractProxy } from "../useExchangeContract";

const renameMap = Object.freeze({
  makerFee: "makerFeePercentage",
  takerFee: "takerFeePercentage",
  royaltiesFee: "royaltiesPercentage",
  collectiveFee: "collectiveFeePercentage",
});

export default function useSettleDutchAuction(dutchAuction: DutchAuctionOrder) {
  const exchangeContract = useExchangeContractProxy();

  return useCallback(
    async (value: string) => {
      const { v, r, s } = getEIP712SignatureParams(dutchAuction.signature!);

      const eip712AuctionObject = buildObject(dutchAuction, renameMap, [
        ...DUTCH_AUCTION_PARAMS,
      ]);

      return await exchangeContract!.bidForDutchAuction(
        v,
        r,
        s,
        dutchAuction.seller,
        eip712AuctionObject,
        { value },
      );
    },
    [dutchAuction, exchangeContract],
  );
}
